import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnimatedLettrs from '../AnimatedLetters/AnimatedLettrs'
import './About.scss'
import { useState, useEffect } from 'react'
import {
  faCss3,
  faFreeCodeCamp,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
type Props = {}

const About = (props: Props) => {
  const [letterClass, setLetterClass] = useState('text-animate')
  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])
  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLettrs
              strArray={'About me'.split('')}
              idx={15}
              letterClass={letterClass}
            />
          </h1>
          <p>
            I'm a very ambitious junior front-end developer{' ('}
            <a
              href="https://drive.google.com/file/d/1vV4Qtn0cIh2krNJXbB7UVWJEL5rGU1aF/view?usp=drive_link"
              target="_blank"
              rel="noreferrer"
            >
              certificate
            </a>
            {') '}
            looking for a role in an established IT company with the opportunity
            to work with the latest technologies on challenging and diverse
            projects.
          </p>
          <p text-align="LEFT">
            I am passionate about the process of coding and I find great
            excitement in it. I enjoy the creative aspect of problem-solving
            through code. I am a proponent of writing code that is not only
            efficient but also easy to maintain and understand by others.
          </p>
          <p>
            I believe in the importance of clean and readable code over more
            concise but cryptic solutions. I have hands-on experience with
            various libraries and frameworks, but I am continually learning and
            open to exploring new technologies that are relevant in today's
            rapidly changing tech landscape.
          </p>
        </div>
        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F65029" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4d28" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faFreeCodeCamp} color="#DD0031" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" active />
    </>
  )
}

export default About
